<div class="form-group">
    <label *ngIf="title">{{title}} {{controlArray | controlRequiredText}}
    </label>

    <i *ngIf="title" [class.d-none]="!tooltip" class="mgn-left-6 pj-ico pj-ico-ayuda-info text-primary"
    data-toggle="popover" data-placement="top"
    data-trigger="hover"
    data-html="true"
    [attr.data-content]="tooltip"
    tabindex="0"></i>

    <div [class.disabled]="controlArray.disabled" [class.dropdown-purple-20]="style === 'purple'"
        class="dropdown dropdown-filter dropdown-input-filter dropdown-input-tag-collapse" [id]="id + '-dp'">
        <button [class.data-required]="controlArray.touched && controlArray.invalid"
            [attr.disabled]="disabled === true ? true : null" class="btn dropdown-toggle dropdown-toggle-no-arrow"
            type="button" [id]="id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span *ngIf="countSelectedValues === 0 || !showValuesOnPlaceholder" [class.text-muted]="style !== 'purple'" >
                {{placeholder}}
            </span>

            <ng-container *ngIf="showValuesOnPlaceholder">
                <ng-container *ngFor="let e of controlArray.controls ; let i = index;">
                    <div *ngIf="e.value===true" class="selection-choice text-capitalize" style="font-weight: 400;">
                        {{dataSelectLabel[i]?.text}}


                        <a *ngIf="controlArray.disabled"   class="selection-choice-remove invisible no-padding" title="Eliminar">&nbsp;</a>
                        <a *ngIf="controlArray.enabled" (click)="onRemoveOption($event,i)"
                            class="selection-choice-remove" title="Eliminar">×</a>
                    </div>
                </ng-container>
            </ng-container>
        </button>
        <div class="dropdown-menu dropdown-menu-filter">
            <div class="mgn-bottom-10" *ngIf="enabledFilter">
                <label [for]="id + '-search'" class="accesibleHidden">{{placeholderSearch}}</label>
                <input type="text" class="form-control filter-input" [id]="id + '-search'"
                    [placeholder]="placeholderSearch" />
            </div>

            <div class="checkbox-group">

                <div class="wrap-checkbox" [class.d-none]="!textSelectAllGroup">
                    <label class="checkbox-label every-checkbox" [for]="id + '-all'">
                        <input class="every-check" type="checkbox" [id]="id + '-all'"
                            (change)="onChangeCheckboxAll($event)" />
                        <span class="checkmark"></span>
                        {{textSelectAllGroup}}
                    </label>
                </div>

                <ng-container *ngFor="let s of controlArray.controls; let i = index">

                    <div class="wrap-checkbox" [class.padding-left-13rem]="textSelectAllGroup"
                        *ngIf="(onlyAvailableFilter === false) || (onlyAvailableFilter === true && dataSelectLabel[i]?.count > 0)">
                        <label class="checkbox-label text-capitalize" [for]="id + i">

                            <input type="checkbox" [id]="id + i" [formControl]="s"
                                [attr.disabled]="enabledCountControl === true && !(dataSelectLabel[i]?.count > 0) ? true : null">
                            <span class="checkmark"></span>
                            <span
                                [class.disabled-checkbox-multi]="enabledCountControl === true && !(dataSelectLabel[i]?.count > 0)">

                                {{dataSelectLabel[i]?.text || dataSelectLabel[i]}}

                                <ng-container *ngIf="enabledCountControl === true ">
                                    ({{dataSelectLabel[i]?.count}})
                                </ng-container>
                            </span>


                        </label>
                    </div>
                </ng-container>

                <div class="no-result-ctn d-none ">
                    No se encontraron resultados
                </div>
            </div>
        </div>
    </div>

    <div-validation-message [control]="controlArray"></div-validation-message>

    <small *ngIf="footer" class="form-text text-muted">{{footer}}</small>

</div>